var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComponentsManagementIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75781 6.3442L12.0005 2.10156L16.2431 6.3442L12.0005 10.5869L7.75781 6.3442ZM10.5863 6.3442L12.0005 4.92998L13.4147 6.3442L12.0005 7.75841L10.5863 6.3442Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10156 12.0004L6.3442 7.75781L10.5869 12.0004L6.3442 16.2431L2.10156 12.0004ZM4.92998 12.0004L6.3442 10.5862L7.75841 12.0004L6.3442 13.4146L4.92998 12.0004Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4141 12.0004L17.6567 16.2431L21.8994 12.0004L17.6567 7.75781L13.4141 12.0004ZM17.6567 10.5862L16.2425 12.0004L17.6567 13.4146L19.071 12.0004L17.6567 10.5862Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75781 17.6567L12.0005 13.4141L16.2431 17.6567L12.0005 21.8993L7.75781 17.6567ZM10.5863 17.6567L12.0005 16.2425L13.4147 17.6567L12.0005 19.0709L10.5863 17.6567Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentsManagementIcon);
export default __webpack_public_path__ + "static/media/componentsManagementIcon.7d0235c6b0ca1cd69021e5b1df718224.svg";
export { ForwardRef as ReactComponent };